import { execOnLoad } from '@general/helpers';
import './page.styleguide.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initStyleguide = (context) => {
  const templateContainer = context.classList.contains('styleguide__container')
    ? context
    : context.closest('.styleguide__container');
  if (!templateContainer) return;

  const rootVariables = [...document.styleSheets].reduce(
    (vars, sheet) =>
      sheet.href !== null && !sheet.href.startsWith(window.location.origin)
        ? vars
        : [
            ...vars,
            ...[...sheet.cssRules].reduce(
              (ruleVars, rule) =>
                rule.selectorText !== ':root'
                  ? ruleVars
                  : [...ruleVars, ...[...rule.style].filter((prop) => prop.startsWith('--'))],
              [],
            ),
          ],
    [],
  );

  const createNode = (variable) => {
    const codeNode = document.createElement('code');
    codeNode.classList.add('styleguide__colors-box');

    const bg = document.createElement('div');
    bg.style.background = `var(${variable})`;
    bg.classList.add('styleguide__colors-box-example');

    const name = document.createElement('div');
    name.innerText = variable;
    name.classList.add('styleguide__colors-box-name');

    const hex = document.createElement('div');
    hex.classList.add('styleguide__colors-box-hex');

    codeNode.append(bg, name, hex);
    return codeNode;
  };

  const lightWrapper = templateContainer.querySelector('.styleguide__colors-mode--light');
  if (lightWrapper)
    rootVariables
      .filter((variable) => variable.startsWith('--light_'))
      .forEach((variable) => {
        lightWrapper.append(createNode(variable));
      });

  const darkWrapper = templateContainer.querySelector('.styleguide__colors-mode--dark');
  if (darkWrapper)
    rootVariables
      .filter((variable) => variable.startsWith('--dark_'))
      .forEach((variable) => {
        darkWrapper.append(createNode(variable));
      });

  templateContainer.querySelectorAll('.styleguide__colors-box').forEach((color) => {
    const example = color.querySelector('.styleguide__colors-box-example');
    const hex = color.querySelector('.styleguide__colors-box-hex');
    if (!example || !hex) return;

    hex.innerText = getComputedStyle(example).backgroundColor;
  });

  templateContainer
    .querySelectorAll('.styleguide__breakpoints [name="active_breakpoint"][type="radio"]')
    .forEach((radio) => radio.addEventListener('click', () => (templateContainer.style.maxWidth = radio.value)));

  const buttonsWrapper = templateContainer.querySelector('.styleguide__buttons');
  if (buttonsWrapper)
    buttonsWrapper
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) =>
        checkbox.addEventListener('click', () =>
          buttonsWrapper.classList.toggle(`styleguide__buttons--${checkbox.name}`),
        ),
      );

  const spacingsWrapper = templateContainer.querySelector('.styleguide__spacings');
  if (spacingsWrapper) {
    const columnsSelect = spacingsWrapper.querySelector('select[name="columns"]');
    const columnsGrid = spacingsWrapper.querySelector('.styleguide__spacings-columns-grid[data-cols]');
    if (columnsSelect && columnsGrid)
      columnsSelect.addEventListener('change', () => (columnsGrid.dataset.cols = columnsSelect.value));
  }
};

execOnLoad(window.dAgency.initStyleguide, '.styleguide__container');
